import React, { Component } from 'react';
import '../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Row, Col, Table, Button } from 'react-bootstrap';
import favicon from '../images/favicon.ico';

import Layout from '../Frame/Layout';
import { Helmet } from "react-helmet";

class Premium extends Component {
    render() {
        return (
            <Layout>
                <Helmet>
                    <title>Premium - Edge.Poker</title>
                    <meta name="description" content="Edge.poker's premium offering allows players to define their own hand range and more to improve outcome of their game." />
                    <meta name="keywords" content="edge poker premium, premium poker odds calculator, hand range poker odds" />
                    <link rel="canonical" href="https://app.edge.poker/premium" />
                    <link rel="icon" href={favicon} />
                    <meta http-equiv="content-language" content="en-us"></meta>
                    <link rel="preload" as="style" href="https://fonts.googleapis.com/css?family=Roboto&display=swap" onload="this.onload=null;this.rel='stylesheet'"></link>  
                    <script src="/sl.js" type='text/javascript'/>
                </Helmet>

                <Row>
                    <Col xs="0" lg="2"/>
                    <Col xs="12" lg="8">
                        <Row>
                            <Col xs="12" className="mb-4 mt-4 text-center">
                                <h1>Edge.Poker Premium</h1>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs="12">
                                <p>
                                    In recent months, Edge.poker has been receiving more interest from users.
                                    As some of loyal users might have noticed, Edge.poker is free-to-use.
                                    In order to deliver better features and more stable service, we are planning to launch a
                                    premium membership.
                                </p>
                                <p>
                                    Users can be rest assured that - Edge.poker will always offer a basic, free service for all.
                                </p>
                            </Col>
                        </Row>
                        <Row className="mt-5">
                            <Col xs="12">
                                <h2>Free vs. Premium</h2>
                                <hr/>
                                <p>
                                    The table below depicts the feature differences between free and the planned premium:
                                </p>
                                <br/>
                                <Table striped bordered hover>
                                    <thead>
                                        <tr>
                                            <th>Features/Benefits</th>
                                            <th>Free</th>
                                            <th>Premium</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Estimate Winning Probability</td>
                                            <td>Y</td>
                                            <td>Y</td>
                                        </tr>
                                        <tr>
                                            <td>Post-Flop Opponent Hand Analysis</td>
                                            <td>Y</td>
                                            <td>Y</td>
                                        </tr>
                                        <tr>
                                            <td>Playing advice</td>
                                            <td>Y</td>
                                            <td>Y</td>
                                        </tr>
                                        <tr>
                                            <td>Edge.poker's hand-range probability estimate</td>
                                            <td>N</td>
                                            <td>Y</td>
                                        </tr>
                                        <tr>
                                            <td>User-defined hand-range probability estimate</td>
                                            <td>N</td>
                                            <td>Y</td>
                                        </tr>
                                    </tbody>
                                </Table>
                                <br/>
                                <p>
                                    With the addition of hand ranges, premium users will be able to play
                                    more often. This will help premium users' winning speed. On top of that,
                                    we will include an exclusive article on bank roll risk management to help
                                    our premium users to become even better players.
                                </p>
                                <p>
                                    We are also constantly looking for new features to bring to our users. If
                                    you have any feature requests, please feel free to&nbsp;
                                    <a href="/contact-us" target="_blank">reach out to us</a>.
                                </p>


                                <h4 className="pt-3">
                                    Effect of Hand Range on Probabilities
                                </h4>
                                <p>
                                    In this section, we will show the difference in the estimated probability 
                                    when no hand range is assumed versus using Edge.poker-defined hand range.
                                    Our hand range data will only be made available to our premium users.
                                </p>
                                <p>
                                    The table below illustrates a few no-hand-range odds vs. Edge.poker-defined
                                    hand-range odds for a 6 players game:
                                </p>
                                <Table striped bordered hover>
                                    <thead>
                                        <tr>
                                            <th>Situation</th>
                                            <th>No hand range (Free) odds</th>
                                            <th>Edge.poker hand range odds</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Pair K</td>
                                            <td>43.38%</td>
                                            <td>55.7%</td>
                                        </tr>
                                        <tr>
                                            <td>Suited AK</td>
                                            <td>32.19%</td>
                                            <td>43.8%</td>
                                        </tr>
                                        <tr>
                                            <td>Pair 10</td>
                                            <td>30.44%</td>
                                            <td>39.6%</td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <div>
                                                    Hand: A &spades;, K &spades;
                                                </div>
                                                <div>
                                                    Shared: K <span className="red">&hearts;</span>, 
                                                    6 <span className="red">&hearts;</span>, 
                                                    6 &spades;, 
                                                    4 <span className="red">&hearts;</span>
                                                </div>
                                            </td>
                                            <td>35.3%</td>
                                            <td>53.7%</td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <div>
                                                    Hand: Q &spades;, Q <span className="red">&hearts;</span>
                                                </div>
                                                <div>
                                                    Shared: 4 &spades;, 
                                                    7 <span className="red">&hearts;</span>, 
                                                    2 <span className="red">&#x2666;</span>
                                                </div>
                                            </td>
                                            <td>41.1%</td>
                                            <td>60.1%</td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>

                        <Row className="mt-5">
                            <Col xs="12">
                                <h2>Limited Early Access</h2>
                                <hr/>
                                <p>
                                    To provide the best possible premium offering at the best price, we are launching
                                    the premium offering in 3 phases:
                                </p>
                                <ul>
                                    <li>Alpha</li>
                                    <li>Beta</li>
                                    <li>General access</li>
                                </ul>

                                <div className="text-center">
                                    <Button href="https://forms.gle/Kkw882gZAm9mFGuY7" target="_blank">
                                        Sign Up for Beta Access
                                    </Button>
                                </div>

                                

                                <div className="mt-5">
                                    <h3>Beta</h3>
                                    <p>In the Beta phase, users can expect a product more refined and closer to the official premium offering. Here are more <b>details</b> of this phase:</p>

                                    <ul>
                                        <li>
                                            <b>Feature delivery</b>: Beta (and Alpha as well) users will have access to features like 
                                            Edge.poker predefined hand range calculator and user-defined hand range calculator. Bugs might
                                            be present and features might change.
                                        </li>
                                        <li>
                                            <b>Access</b>: One time fee of <b>$13.50</b> for the entire beta period.
                                        </li>
                                        <li>
                                            <b>Access time period</b>: Beta trial period.
                                        </li>
                                        <li>
                                            <b>Beta trial period</b>: 3 months or more.
                                        </li>
                                        <li>
                                            <b>Beta start date</b>: In a future date
                                        </li>
                                        <li>
                                            <b>User limit</b>: 350. 
                                        </li>
                                    </ul>

                                    <h5 className="mt-3">
                                        Perks for Beta Users
                                    </h5>

                                    <p>
                                        In order to thank our beta users' support, we will issue
                                        a 1-year 25% discount coupon applicable to Beta users once the premium 
                                        plan starts to be a paid offering.
                                    </p>
                                </div>

                                <div className="mt-5">
                                    <h3>Sign up</h3>

                                    <p>
                                        Beta users can sign up using this link below:
                                    </p>

                                    <div className="text-center pb-5 pt-3">
                                        <Button href="https://forms.gle/Kkw882gZAm9mFGuY7" target="_blank">
                                            Sign Up for Beta Access
                                        </Button>
                                    </div>

                                    <p>
                                        Enrollment for the Alpha and Beta trial is based on a first-come first-served
                                        basis. If you don't get enrolled into Alpha, you will
                                        automatically be considered for Beta.
                                    </p>
                                    <p>
                                        Signing up is totally free. For the Beta trial, you will receive
                                        an email sending you to a unique Beta sign up page where you will
                                        be able to make the one-time payment. Of course, Alpha users will 
                                        not have to worry about any payment at all. But, you will still
                                        receive an email asking you to login and change your password once
                                        the Alpha offering is available.
                                    </p>
                                    <p>
                                        We will update the number of Alpha and Beta users every week. 
                                        Once a particular trial has reached its targeted signed up users, 
                                        we will also highlight it on this page.
                                    </p>
                                </div>

                                <div className="mt-5">
                                    <h3>Alpha (Expired)</h3>
                                    <p>This phase is meant for very raw offering of the initial premium offering. Here are more <b>details</b> of this phase:</p>

                                    <ul className="mb-3">
                                        <li>
                                            <b>Feature delivery</b>: Alpha users will get continuous delivery of the 
                                            latest premium feature sets. Expect to see bugs from time-to-time. 
                                            The very first feature that Alpha users will have access to is Edge.poker
                                            defined hand-range. This will allow Alpha users to play more aggressively.
                                        </li>
                                        <li>
                                            <b>Access</b>: Free.
                                        </li>
                                        <li>
                                            <b>Free access time period</b>: Alpha trial period + Beta trial period.
                                        </li>
                                        <li>
                                            <b>Alpha trial period</b>: Roughly 5 months.
                                        </li>
                                        <li>
                                            <b>Alpha start date</b>: Ended
                                        </li>
                                        <li>
                                            <b>Our expectation from Alpha users</b>: Provide feedback to help us
                                            improve the product. 
                                        </li>
                                        <li>
                                            <b>User limit</b>: 30 (Less than 10 left). 
                                        </li>
                                    </ul>

                                    <h5 className="mt-3">
                                        Perks for Alpha Users
                                    </h5>

                                    <p>
                                        In order to thank the early enthusiasm from our alpha users, we will issue
                                        a 50% discount coupon applicable for 1 year once the premium plan starts to be a 
                                        paid offering.
                                    </p>
                                </div>
                            </Col>
                        </Row>

                        <Row className="mt-5">
                            <Col xs="12">
                                <h2>General Access</h2>
                                <hr/>
                                <p>
                                    While we don't have all the details for paid premium offering, we can
                                    shed some light on how the paid premium plan would look like:
                                </p>
                                <ul>
                                    <li>There will be likely at least 2 plans - a quarterly paid plan and an annually paid plan.</li>
                                    <li>The cheapest plan (which is likely going to be an annual plan) will be priced at least $6 per month.</li>
                                    <li>General access will likely start in late 2025.</li>
                                </ul>
                            </Col>
                        </Row>
                    </Col>
                    <Col xs="0" lg="2"/>
                </Row>
            </Layout>
        )
    }
}

export default Premium;